import { render, staticRenderFns } from "./MilestoneBadge.vue?vue&type=template&id=280bd57c&"
import script from "./MilestoneBadge.vue?vue&type=script&lang=js&"
export * from "./MilestoneBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports